module.exports = __webpack_public_path__ + "media/img/why/client1-1e6995d7b7618d0bf4d295ed9ae599d8.png";